import StoriesBanner from '@/scenes/Stories/Banner';
import StoriesCTA from '@/scenes/Stories/CTA';
import SpaceStory from '@/scenes/Stories/SpaceStory';
import StoriesList from '@/scenes/Stories/List';

interface Props {
  content: any;
}

const StoriesScene = ({ content }: Props) => {
  return (
    <main>
      <StoriesBanner {...content.banner} />
      <SpaceStory />
      <StoriesList />
      <StoriesCTA
        title={content.cta.title}
        description={content.cta.description}
      />
    </main>
  );
};

export default StoriesScene;
